import {Image, Typography} from "antd"
import React from "react"

export function NavTileItem({icon, title}) {
  return (
    <div className="nav-tile-item">
      <Image preview={false} src={icon}></Image>
      <Typography.Title level={4}>{title}</Typography.Title>
    </div>
  )
}